/**@jsx jsx */
import { jsx, Flex } from 'theme-ui'

const style = {
  iconContainer: {
    fontSize: '24px',
  },
  icon: {
    backgroundImage: 'linear-gradient(90deg,#705ecf 0%,#E50A68 100%)',
    '-webkit-background-clip': 'text',
    '-webkit-text-fill-color': 'rgba(255, 255, 255, 0)',
    transition: 'all 0.5s',
    '&:hover': {
      transform: 'scale(1.5)',
    },
  },
}

const Socials = ({
  company_website,
  company_facebook,
  company_insta,
  company_linkedin,
  company_twitter,
}) => {
  return (
    <Flex
      className="socials"
      sx={{
        justifyContent: 'center',
        marginBottom: '20px',
        marginTop: '20px',
      }}
    >
      <ul
        sx={{
          listStyle: 'none',
          display: 'inline-flex',
          justifyContent: 'space-between',
          width: '200px',
        }}
      >
        {company_website && (
          <li className="platform" sx={style.iconContainer}>
            <a href={company_website} target="_blank" rel="noopener noreferrer">
              <span sx={style.icon} className="fas fa-link"></span>
            </a>
          </li>
        )}

        {company_facebook && (
          <li className="platform" sx={style.iconContainer}>
            <a href={company_facebook} target="_blank" rel="noopener noreferrer">
              <span sx={style.icon} className="fab fa-facebook-f"></span>
            </a>
          </li>
        )}

        {company_insta && (
          <li className="platform" sx={style.iconContainer}>
            <a href={company_insta} target="_blank" rel="noopener noreferrer">
              <span sx={style.icon} className="fab fa-instagram"></span>
            </a>
          </li>
        )}

        {company_twitter && (
          <li className="platform" sx={style.iconContainer}>
            <a href={company_twitter} target="_blank" rel="noopener noreferrer">
              <span sx={style.icon} className="fab fa-twitter"></span>
            </a>
          </li>
        )}

        {company_linkedin && (
          <li className="platform" sx={style.iconContainer}>
            <a href={company_linkedin} target="_blank" rel="noopener noreferrer">
              <span sx={style.icon} className="fab fa-linkedin-in"></span>
            </a>
          </li>
        )}
      </ul>
    </Flex>
  )
}

export default Socials
